import { FC } from 'react';
import { Routes } from 'routes';
import { LoadingProvider } from 'hooks/useLoading';
// Firebase initialization
import 'services/firebase.service';

export const App: FC = () => {
  return (
    <LoadingProvider>
      <Routes />
    </LoadingProvider>
  );
};

